export interface ReactionArgument {
  id?: number
  messageId: string
  userId: string
  emoji: string
  createdAt?: Date
}

export default class Reaction {
  readonly id?: number
  readonly messageId: string
  readonly userId: string
  readonly emoji: string
  readonly createdAt: Date

  constructor(arg: ReactionArgument) {
    this.id = arg.id
    this.messageId = arg.messageId
    this.userId = arg.userId
    this.emoji = arg.emoji
    this.createdAt = arg.createdAt ?? new Date()
  }

  static fromPG(data: any): Reaction {
    return new Reaction({
      id: data.id,
      messageId: data.message_id,
      userId: data.user_id,
      emoji: data.emoji,
      createdAt: new Date(data.created_at),
    })
  }

  toPG(): any {
    return {
      id: this.id,
      message_id: this.messageId,
      user_id: this.userId,
      emoji: this.emoji,
      created_at: this.createdAt.toISOString(),
    }
  }
}
